/**
 * BaseFretebasCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {BaseFretebas} from '@/model/resource/BaseFretebas'

/* TODO: review generated class */
@HttpExclude()
export class BaseFretebasCollection extends PageCollection<BaseFretebas> {
  constructor() {
    super(BaseFretebas)
  }

  queryAsPage() {
    return this.listBaseFretebas()
  }

  async listBaseFretebas() {
    return await Request.get(`/admin/base-fretebas`, {params: this.params})
      .name('listBaseFretebas')
      .as(this)
      .getResponse()
  }

  async listCsvBaseFretebas() {
    return await Request.get(`/admin/base-fretebas/csv`, {params: this.params})
      .name('listCsvBaseFretebas')
      .as(this)
      .getResponse()
  }
}
